import { TaskContext } from "contexts/TaskDetailContext";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../redux/common/actions";
import { getModelTaskTools } from "services/models/modelDetails/modelTaskTools";
import { ModelContext } from "contexts/ModelDetailContext";
import i18n from "i18n";

export default function useModelTaskTools({ taskInfo, isMounted }) {
	const [originalTools, setOriginalTools] = useState([]);
	const [tools, setTools] = useState([]);
	const [loading, setLoading] = useState(true);
	// hook
	const dispatch = useDispatch();
	// ctx
	const [, CtxDispatch] = useContext(TaskContext);
	const [state, MdxDispatch] = useContext(ModelContext);
	const fetchTools = async (showLoading = true) => {
		!isMounted.aborted && showLoading && setLoading(true);
		try {
			const response = await getModelTaskTools(taskInfo.id);
			if (response.status) {
				if (!isMounted.aborted) {
					setTools(response?.data);
					setOriginalTools(response?.data);
				}
				CtxDispatch({
					type: "TAB_COUNT",
					payload: {
						countTab: "toolCount",
						data: response?.data?.length,
					},
				});
				if (response.data.length > 0) {
					CtxDispatch({
						type: "SET_TOOLS",
						payload: true,
					});
				} else {
					CtxDispatch({
						type: "SET_TOOLS",
						payload: false,
					});
				}
			} else {
				dispatch(
					showError(
						response?.data?.title ||
							response?.data ||
							i18n.t("message.couldNotFetchTaskTools")
					)
				);
			}
		} catch (error) {
			dispatch(
				showError(
					error?.response?.data ||
						error?.response ||
						i18n.t("message.couldNotFetchTaskTools")
				)
			);
		} finally {
			!isMounted.aborted && showLoading && setLoading(false);
		}
	};

	useEffect(() => {
		fetchTools();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		MdxDispatch,
		fetchTools,
		loading,
		originalTools,
		setLoading,
		setOriginalTools,
		setTools,
		state,
		tools,
	};
}
